const FixtureGetSubscriptionsByIdActivePrepaid = {
  success: {},
  payload: {
    subscription: {
      id: { id: "TEST-ID-ACTIVE-PREPAID" },
      user_id: { id: "5e0b13e5-aa4c-484d-97fe-de52eaff7177" },
      status: "ACTIVE",
      next_billing_date: "2026-02-28T10:00:00.863710Z",
      last_billing_date: "0001-01-01T00:00:00Z",
      start_date: "2026-02-28T11:11:12Z",
      expiration_date: "0001-01-01T00:00:00Z",
      cancellation_cause: "UNKNOWN",
      created_at: "2024-02-29T11:11:12.250483Z",
      updated_at: "2024-02-29T13:31:31.900364Z",
      recurly_subscription_id: "",
      stripe_subscription_id: "sub_1Op7W8IB8GJCWHfofViLXKYX",
      activated_at: "2024-02-29T11:11:12Z",
      cancellation_date: "0001-01-01T00:00:00Z",
      device_sns: ["N1-605944814"],
      internal_id: null,
      coupon_codes: [],
      subscription_quantity: 2,
      prepaid_period_days: 0,
      trial_period_days: 730,
      subscription_type: "PREPAID_SUBSCRIPTION",
    },
  },
};
export default FixtureGetSubscriptionsByIdActivePrepaid;
